import { styled } from '@mui/material/styles';
import { Typography, Box, Card } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useCreateConsoleAuthForm, ConsoleAuthForm } from '../sections/consoleAuth/createConsoleAuthForm';

// Styles
const MainSection = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  flexDirection: 'column',
  gap: '14px',
  padding: '76px 82px 12px 140px',
  height: '100%',
  overflowY: 'scroll',
  [theme.breakpoints.down('sm')]: {
    padding: '70px 14px 14px 14px',
    height: 'auto',
  },
}));

const HeadingTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[1000],
  fontSize: '20px',
  fontWeight: 600,
}));

const FormSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  gap: '10px',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export default function CreateConsoleAuth() {
  const navigate = useNavigate();
  const { formValues, errors, loading, handleChange, handleSubmit } = useCreateConsoleAuthForm(navigate); // ✅ include errors

  return (
    <MainSection>
      <Box sx={{ width: '100%' }}>
        <HeadingTypography>Create ConsoleAuth Token</HeadingTypography>
      </Box>
      <FormSection>
        <Card sx={{ width: '100%' }}>
          <ConsoleAuthForm
            formValues={formValues}
            errors={errors} // ✅ pass errors
            loading={loading}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
          />
        </Card>
      </FormSection>
    </MainSection>
  );
}
